import { autorun } from 'mobx';
import { useEffect } from 'react';
import { useRootStore } from '@nandosaus/state-management';
import { useRouter } from 'next/router';

import { navigation } from '../../constants';
import { setLandingPage } from '../../utils/auth';

const useRedirectIfUnauthenticated = () => {
  const router = useRouter();
  const { MemberStore } = useRootStore();

  useEffect(() => {
    const disposer = autorun(() => {
      if (!MemberStore.isSignedIn && !MemberStore.loading) {
        setLandingPage(router.asPath);
        router.push(navigation.SIGN_IN);
      }
    });
    return () => disposer();
  }, [MemberStore, router]);
};

export { useRedirectIfUnauthenticated };
